module.exports = __webpack_public_path__ + "img/BRCA4_B.06d5ab30.png";